(function () {
  var cache = {};
  var inFlight = {};

  window.kikaSnize = window.kikaSnize || {};

  function extractHandle(card) {
    var link = card.querySelector('a.snize-view-link') || card.querySelector('a[href*="/products/"]');
    if (!link && card.matches && card.matches('a[href*="/products/"]')) link = card;
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function getVariantId(card) {
    if (card.dataset.kikaSelectedVariant) return card.dataset.kikaSelectedVariant;
    var link = card.querySelector('a.snize-view-link');
    if (!link && card.matches && card.matches('a[href]')) link = card;
    if (!link) return null;
    var m = link.getAttribute('href').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function injectBadge(card, doc) {
    // Remove existing
    var prev = card.querySelector('.ksd-injected-badge');
    if (prev) prev.parentNode.removeChild(prev);

    var badgeWrap = doc.querySelector('[data-ksd="badge"]');
    if (!badgeWrap) return;

    var overlay = badgeWrap.querySelector('.product-card__overlay');
    if (!overlay) return;

    var wrapper = card.querySelector('.snize-thumbnail-wrapper') || card.querySelector('.snize-thumbnail');
    if (!wrapper) return;
    wrapper.style.position = 'relative';

    var container = document.createElement('div');
    container.className = 'ksd-injected-badge';
    container.style.cssText = 'position:absolute;top:0;left:0;z-index:3;pointer-events:none;width:100%;flex:1;';
    container.appendChild(overlay);
    wrapper.appendChild(container);
  }

  function injectPrice(card, doc) {
    var priceWrap = doc.querySelector('[data-ksd="price"]');
    if (!priceWrap) return;

    var section = document.createElement('div');
    section.className = 'ksd-price-section';
    section.innerHTML = priceWrap.innerHTML;

    var existing = card.querySelector('.ksd-price-section');
    if (existing) {
      // Refresh — replace in place so position in DOM is preserved
      existing.parentNode.replaceChild(section, existing);
    } else {
      // First load — replace Searchanise's native price list
      var snizePrice = card.querySelector('.snize-price-list');
      if (!snizePrice) return;
      snizePrice.parentNode.replaceChild(section, snizePrice);
    }
  }

  function fetchAndInject(card, handle, variantId) {
    var cacheKey = handle + (variantId ? '__' + variantId : '');

    if (cache[cacheKey] !== undefined) {
      var doc = cache[cacheKey];
      if (doc) { injectBadge(card, doc); injectPrice(card, doc); }
      return;
    }

    var waiters = inFlight[cacheKey];
    if (waiters) { waiters.push(card); return; }
    inFlight[cacheKey] = [card];

    var url = '/products/' + encodeURIComponent(handle) + '?sections=kika-discount-badge';
    if (variantId) url += '&variant=' + encodeURIComponent(variantId);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (data) {
        var html = (data['kika-discount-badge'] || '').trim();
        var doc = html ? new DOMParser().parseFromString(html, 'text/html') : null;
        cache[cacheKey] = doc;
        (inFlight[cacheKey] || []).forEach(function (c) {
          if (doc) { injectBadge(c, doc); injectPrice(c, doc); }
        });
        delete inFlight[cacheKey];
      })
      .catch(function () {
        cache[cacheKey] = null;
        delete inFlight[cacheKey];
      });
  }

  function processCard(card) {
    if (card.dataset.kikaBadge) return;
    card.dataset.kikaBadge = '1';

    var handle = extractHandle(card);
    if (!handle) return;
    fetchAndInject(card, handle, getVariantId(card));
  }

  // Called by snize-variants.js when a variant pill is clicked
  window.kikaSnize.refreshCard = function (card, variantId) {
    var handle = extractHandle(card);
    if (!handle) return;
    // Bust cache for this variant so we always get fresh data
    var cacheKey = handle + '__' + variantId;
    delete cache[cacheKey];
    fetchAndInject(card, handle, variantId);
  };

  var CARD_SELECTOR = 'li.snize-product, a.snize-item';

  function scanCards(root) {
    (root || document).querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      if (!card.dataset.kikaBadge) processCard(card);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(CARD_SELECTOR)) {
          processCard(node);
        } else {
          scanCards(node);
        }
      });
    });
  });

  function init() {
    scanCards(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
